import { Component, Input, output } from '@angular/core';

import { Analytics } from '@recruitee/analytics';
import { TranslatePipe } from '@recruitee/i18n';
import {
  DropdownItemComponent,
  IconComponent,
  IntegrationItemComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-slack-integration',
  templateUrl: './slack-integration.component.html',
  imports: [IntegrationItemComponent, IconComponent, TranslatePipe, DropdownItemComponent],
})
export class SlackIntegrationComponent {
  @Input() public hasSlackIntegrations: boolean;
  @Input() public isSlackIntegrationLoaded: boolean;
  public edit = output<void>();
  public integrate = output<void>();
  public disconnect = output<void>();

  constructor(public analytics: Analytics) {}
}
